import React from 'react'
import { ClipLoader } from 'react-spinners'

const CommonLoader: React.FC = () => {
    return (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-light bg-opacity-50 d-flex justify-content-center align-items-center" style={{ zIndex: 10500, pointerEvents: 'none' }}>
            <div className="position-absolute w-100 h-100 bg-blur" style={{ backdropFilter: 'blur(2px)', pointerEvents: 'none' }}></div>
            <ClipLoader
                size={50}
                color="#2c6a3f"
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}

export default CommonLoader
